import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import RowNoData from '@/components/elements/RowNoData';
import { ChatObj, MensajesChatObj } from '@/objects/Chat';
import RowChat from '@/components/elements/listas/lista_mensajes/RowChat';

function Mensajes() {

    const { mensajesQueries } = useServices();

    const [chats, setChats] = React.useState<ChatObj[]>([]);
    //para modificar algun chat:
    const [chatModificado, setChatModificado] = React.useState<ChatObj | null>(null);

    const { t } = useTranslation();

    useEffect(() => {
        cargarChats();
    }, []);

    useEffect(() => {
        if (chatModificado) {
            //alert(JSON.stringify(chatModificado));
            //console.log("chatModificado", chatModificado);
            const index = chats.findIndex((chat: ChatObj) => chat.id_chat == chatModificado.id_chat);
            if (index != -1) {
                const chatsModificados = chats;
                chatsModificados[index] = chatModificado;
                setChats(chatsModificados);
            }
        }
    }, [chatModificado]);


    function cargarChats() {
        const datosUsuario = cargarDatosUsuario();
        mensajesQueries?.obtenerListaChats(Number(datosUsuario?.id_user)).then((response: AxiosResponse<ChatObj[]>) => {
            //setChats(response.data.chats);
            const chatsTotales: ChatObj[] = response.data;

            mensajesQueries?.obtenerMensajesNoLeidos(Number(datosUsuario?.id_user)).then((response: AxiosResponse<MensajesChatObj[]>) => {
                //alert(JSON.stringify(response.data));
                // setChats(response.data.chats);
                if (response.status == 200) {
                    const chatSinLeer: MensajesChatObj[] = response.data;
                    const chats: ChatObj[] = [];
                    chatsTotales.forEach((chat: ChatObj) => {
                        const chatsSinLeerDelChat = chatSinLeer.filter((chatSinLeer: MensajesChatObj) => chatSinLeer.id_chat == chat.id_chat);
                        if (chatsSinLeerDelChat.length > 0) {
                            chat.leido = chatsSinLeerDelChat.length;
                        }
                        chats.push(chat);
                    });
                    //ordenalos por fechaMod
                    chats.sort((a: ChatObj, b: ChatObj) => {
                        const fechaA = new Date(a.fecha_mod);
                        const fechaB = new Date(b.fecha_mod);
                        return fechaB.getTime() - fechaA.getTime();
                    });
                    setChats(chats);
                }
            }
            ).catch((error: any) => {

            });
        }
        ).catch((error: any) => {

        });
    }

    const styleMargin: React.CSSProperties = {
        margin: "20px"
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                {chats.length > 0 ? chats.map((chat: ChatObj, index: number) => {
                    return (
                        <section style={{ display: 'flex', flexDirection: 'column', width: "100%", margin: "10px", alignItems: "center" }} key={index}>
                            <RowChat chat={chat} t={t} setChat={setChatModificado} />
                        </section>
                    );
                }) : <RowNoData texto={t("menu:secciones.mensajes.no_hay_mensajes")} />}
            </section>
        </section>
    );
}

export default Mensajes;